// extracted by mini-css-extract-plugin
export default {"start_button":"Start_start_button__WX95c"};